import React, { useState, useEffect } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import DirectoryApi from "../../../api/directoryApi";
import { toast } from "react-toastify";
import { Form, Button, Modal } from "react-bootstrap";
import { Cookies } from "react-cookie";

const DirectoryModel = ({ show, onHide, directory, retreatData }) => {
  const [validated, setValidated] = useState(false);
  const [headerText, setHeaderText] = useState("");
  const [saving, setSaving] = useState(false);
  let directoryApi = new DirectoryApi();
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;

  useEffect(() => {
    setHeaderText((directory && directory.footerText) || "");
  }, [directory, show]);

  const handleSubmit = () => {
    if (saving) return;
    setSaving(true);
    setValidated(true);
    directoryApi
      .createDirectory({
        headerText: headerText,
        retreatId:
          (directory && directory.retreatId) || (retreatData && retreatData.id),
        directoryId: directory && directory.id,
      })
      .then(async (res) => {


        if (res.success) {
          toast.success(res.msg);
          onHide();
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      className="directory-footer-modal"
      dialogClassName="directory-footer-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Footer Text
          </Modal.Title>
          <p className="directory-footer-hint">
            This text shows at the bottom of the Directory. Use the toolbar to
            format it, then save.
          </p>
        </div>
      </Modal.Header>
      <Form
        noValidate
        validated={validated}
        className="forms-sample"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <Modal.Body>
          <div className="directory-footer-editor">
            <SunEditor
              id="directory-footer-text-editor"
              type="text"
              autoFocus={true}
              placeholder="Write the Directory Footer text here..."
              onChange={(e) => setHeaderText(e)}
              setContents={headerText}
              name="quote"
              height="520px"
              disable={saving}
              setOptions={{
                height: "520px",
                minHeight: "520px",
                resizingBar: true,
                placeholder: "Write the Directory Footer text here...",
                defaultStyle: "font-size: 16px; line-height: 1.65;",
                buttonList: [
                  ["undo", "redo", "font", "fontSize", "formatBlock"],
                  ["bold", "underline", "italic", "removeFormat"],
                  [
                    "fontColor",
                    "hiliteColor",
                    "outdent",
                    "indent",
                    "align",
                    "horizontalRule",
                    "list",
                    "lineHeight",
                  ],
                  ["fullScreen", "link"],
                ],
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={onHide} disabled={saving}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="primary"
            type="button"
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Footer Text"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DirectoryModel;
